import { useQuery } from '@apollo/client';
import { getSingleEntitySchema } from '../application/query';
const useGetSingleEntitySchema = (id, skip = false) => {
  const {
    loading,
    error,
    data
  } = useQuery(getSingleEntitySchema, {
    variables: {
      id
    },
    skip
  });
  return {
    loading,
    error,
    data
  };
};
export default useGetSingleEntitySchema;
//# sourceMappingURL=use-get-single-entity-schema.js.map